import { createAsyncThunk } from '@reduxjs/toolkit';
import CapitalPartnersService from '_services/capital-partners';

export const fetchCapitalPartners = createAsyncThunk(
  'capital-partners/fetch-capital-partners',
  (_, { rejectWithValue }) =>
    CapitalPartnersService.getCapitalPartnersList().catch(rejectWithValue),
);
